

















import { Component, Vue, Prop } from "vue-property-decorator";
import { BblAlertItem } from "@/types/catatan_harian_bbl";

@Component
export default class BblAlertBanner extends Vue {
  @Prop({ type: Array, default: () => [] }) readonly alerts!: BblAlertItem[];

  get hasCritical(): boolean {
    return this.alerts.some((a) => a.level === "critical");
  }
}
